import {SubPageMenuListItemButton} from "base/component/presentational";

import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import TopicOutlinedIcon from "@mui/icons-material/TopicOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import {ChangesMenuListItemButtom, ChangesSubPageMenu} from "changes/presentational";

const DepositoSubPageMenu = ({deposito}) => {
    return (
        <ChangesSubPageMenu
            pending_status={deposito.pending_status}
            headingPrimaryText={deposito.codigo || deposito.id}
            headingSecondaryText="Depósito"
        >
            <SubPageMenuListItemButton
                to="summary"
                text="Ficha"
                icon={<AssignmentOutlinedIcon />}
            />
            <SubPageMenuListItemButton
                to="detail"
                text="Datos"
                icon={<ViewListOutlinedIcon />}
            />
            <SubPageMenuListItemButton
                to="documents"
                text="Documentos"
                icon={<TopicOutlinedIcon />}
            />
            <ChangesMenuListItemButtom entity={deposito} />
        </ChangesSubPageMenu>
    );
};

export default DepositoSubPageMenu;
